module.exports = __webpack_public_path__ + "img/loginbackground.7c62ffe5.jpeg";